export const API_URL = 'https://doofy-shop-server.vercel.app/api';
// http://localhost:8000
